export default __webpack_public_path__ + "static/media/add-icon.208820ff.svg";